import { MappedComponentProperties } from "@adobe/aem-react-editable-components";
import extractModelId from "../../utils/extract-model-id";
import {
  HeroSmall,
  HeroSmallData,
} from "../../ui.lib/components/shared/hero-small";

const HeroSmallComponent = (props: MappedComponentProperties & { data: any }) => {
  console.log(props);
  const { data } = props;
  const { heroSmall } = data;

  const CMS_HERO_SMALL_DATA: HeroSmallData = {
    id: data?.id,
    breadcrumbs: {
      items: heroSmall?.heroBreadcrumbItems
    },
    displayPattern: heroSmall?.heroSmallDisplayPattern,
    patternId: heroSmall?.heroSmallPatternId,
    eyebrow: heroSmall?.heroSmallEyebrow,
    title: heroSmall?.heroSmallTitle,
    descriptionHTML: {
      __html: heroSmall?.heroSmallDescriptionHTML,
    },
    ctas: heroSmall?.heroSmallctas,
    hideBreadcrumb: heroSmall?.hideBreadcrumb
  };

  return (
    <div id={extractModelId(props.cqPath)}>
      <HeroSmall data={CMS_HERO_SMALL_DATA}></HeroSmall>
    </div>
  );
};

export default HeroSmallComponent;
